import classNames from 'classnames';
import React from 'react';

import {Button, IconButton, Text} from '@albert-io/atomic';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {
  classroomId: string | undefined;
}

export default function StudentHomepageHeader({className, classroomId}: Props) {
  const classrooms = useStudentDashboard((state) => state.classrooms);
  const isSidebarExpanded = useStudentDashboard((state) => state.isSidebarExpanded);
  const setIsSidebarExpanded = useStudentDashboard((state) => state.setIsSidebarExpanded);
  const setShowJoinClassModal = useStudentDashboard((state) => state.setShowJoinClassModal);

  const currentClassroomName =
    classrooms.find((classroom) => classroom.getId() === classroomId)?.getName() ?? 'Home';

  return (
    <div className={classNames('flex items-center px-x1 pt-x3 s:px-x3', className)}>
      <IconButton
        className='mr-x1'
        icon='bars'
        label='Toggle sidebar button'
        onClick={() => {
          setIsSidebarExpanded(!isSidebarExpanded);
        }}
      />
      <Text className='mr-x2 flex-1 font-black' size='xl'>
        {currentClassroomName}
      </Text>
      <Button
        onClick={() => {
          setShowJoinClassModal(true);
        }}
        roundness='pill'
      >
        Join Class
      </Button>
    </div>
  );
}
